import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { avatarInitials } from "../display/Avatar.js";
import { cx } from "../internal/cx.js";
import { useControllableState } from "./hooks.js";
import { SignOutIcon } from "./icons.js";
import { renderShellLink } from "./links.js";
import { useAppShell } from "./ShellContext.js";
import { MenuRoot } from "../vendor/@base-ui/react/menu/root/MenuRoot.js";
import { MenuTrigger } from "../vendor/@base-ui/react/menu/trigger/MenuTrigger.js";
import { MenuPortal } from "../vendor/@base-ui/react/menu/portal/MenuPortal.js";
import { MenuPositioner } from "../vendor/@base-ui/react/menu/positioner/MenuPositioner.js";
import { MenuPopup } from "../vendor/@base-ui/react/menu/popup/MenuPopup.js";
import { MenuGroup } from "../vendor/@base-ui/react/menu/group/MenuGroup.js";
import { MenuGroupLabel } from "../vendor/@base-ui/react/menu/group-label/MenuGroupLabel.js";
import { MenuLinkItem } from "../vendor/@base-ui/react/menu/link-item/MenuLinkItem.js";
import { MenuItem } from "../vendor/@base-ui/react/menu/item/MenuItem.js";
import { Separator } from "../vendor/@base-ui/react/separator/Separator.js";
const UserMenu = React.forwardRef(function UserMenu2({
  name,
  detail,
  initials,
  avatar,
  items = [],
  onSignOut,
  signOutLabel = "Sign out",
  triggerLabel,
  open: openProp,
  defaultOpen = false,
  onOpenChange,
  renderLink,
  className,
  ...rest
}, ref) {
  const shell = useAppShell();
  const linkRenderer = renderLink ?? shell?.renderLink;
  const [open, setOpen] = useControllableState(openProp, defaultOpen, onOpenChange);
  return /* @__PURE__ */ jsxs(MenuRoot, { open, onOpenChange: (next) => setOpen(next), children: [
    /* @__PURE__ */ jsx(
      MenuTrigger,
      {
        ref,
        className: cx("ev-avatar-button", className),
        "aria-label": triggerLabel ?? `Account menu, ${name}`,
        ...rest,
        children: /* @__PURE__ */ jsx("span", { className: "ev-avatar", "aria-hidden": "true", children: avatar ?? initials ?? avatarInitials(name) })
      }
    ),
    /* @__PURE__ */ jsx(MenuPortal, { children: /* @__PURE__ */ jsx(MenuPositioner, { className: "ev-menu-positioner", side: "bottom", align: "end", sideOffset: 8, children: /* @__PURE__ */ jsxs(MenuPopup, { className: "ev-menu ev-root ev-user-menu", children: [
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        /* @__PURE__ */ jsxs(MenuGroupLabel, { className: "ev-user-menu__head", children: [
          /* @__PURE__ */ jsx("b", { children: name }),
          detail != null && /* @__PURE__ */ jsx("small", { children: detail })
        ] }),
        items.map((item) => {
          const content = /* @__PURE__ */ jsxs(Fragment, { children: [
            item.icon != null && /* @__PURE__ */ jsx("span", { className: "ev-menu__icon", "aria-hidden": "true", children: item.icon }),
            item.label
          ] });
          if (item.href != null && !item.disabled) {
            const href = item.href;
            return /* @__PURE__ */ jsx(
              MenuLinkItem,
              {
                className: "ev-menu__item",
                closeOnClick: true,
                render: (props) => renderShellLink(linkRenderer, { ...props, href, children: content }, { id: item.id, href })
              },
              item.id
            );
          }
          return /* @__PURE__ */ jsx(MenuItem, { className: "ev-menu__item", disabled: item.disabled, onClick: item.onSelect, children: content }, item.id);
        })
      ] }),
      onSignOut && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Separator, { className: "ev-menu__sep" }),
        /* @__PURE__ */ jsxs(MenuItem, { className: "ev-menu__item", onClick: onSignOut, children: [
          /* @__PURE__ */ jsx("span", { className: "ev-menu__icon", "aria-hidden": "true", children: /* @__PURE__ */ jsx(SignOutIcon, {}) }),
          signOutLabel
        ] })
      ] })
    ] }) }) })
  ] });
});
export {
  UserMenu
};
//# sourceMappingURL=UserMenu.js.map
